import useSWR from "swr";
import Link from "next/link";
import { useState } from "react";
import { getCookie } from "cookies-next";
import { getDeliveryDetails } from "@/services/product";

const DeliveryInformations = ({ locale }) => {
  const regionId =
    getCookie("region_id") &&
    getCookie("region_id") !== "NaN" &&
    getCookie("region_id") !== "undefined"
      ? getCookie("region_id")
      : "1101";

  const [state, setState] = useState({
    insideRiyadh: regionId === "1101",
    delivery: [],
  });

  useSWR("pdp-delivery-details", getDeliveryDetails, {
    revalidateOnFocus: false,
    onSuccess: ({ data }) => {
      setState((prev) => ({
        ...prev,
        delivery: data?.data?.active_details || [],
      }));
    },
  });

  return (
    <div className="grid grid-cols-2 gap-1 border border-[#F0F0F0] rounded-[10px] mb-4">
      {state?.delivery?.map((info, index) => (
        <div
          key={index}
          className="bg-[#FAFAFA] max-sm:min-h-14 max-sm:max-h-14 min-h-[65px] rounded-tr-[10px] max-h-[65px] flex flex-col items-center justify-center gap-[5px]"
        >
          <h3 className="text-lg font-medium max-sm:text-sm">
            {info?.[`title_${locale}`]}
          </h3>
          <p className="text-xs text-[#71717A]">
            {info?.[`descriptions_${locale}`]}
          </p>
        </div>
      ))}
      <Link
        href="/fast-delivery"
        target="_blank"
        className="col-span-full bg-[#FAFAFA] max-sm:min-h-8 max-sm:max-h-8 min-h-10 max-h-10 flex items-center justify-center text-xs text-[#6B7280] underline hover:no-underline"
      >
        {locale === "en" ? "Terms and conditions" : "الشروط والأحكام"}
      </Link>
    </div>
  );
};

export default DeliveryInformations;
